import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const CurrencyFormatterContent = ({
  containerProps, prefix, tagName: WrapTag, icon, withSign,
  formattedValue, showSuffix, currency,
}) => (
  <WrapTag {...containerProps}>
    {prefix && (
      <Fragment>
        &nbsp;
        {prefix}
        &nbsp;
      </Fragment>
    )}
    <span className="icon-val-wrapper">
      {icon}
      {withSign}
      {formattedValue}
      {(!icon || showSuffix) && (
        <Fragment>
          &nbsp;
          {currency}
        </Fragment>
      )}
    </span>
  </WrapTag>
);

CurrencyFormatterContent.defaultProps = {
  icon: '',
  currency: '',
};

CurrencyFormatterContent.propTypes = {
  containerProps: PropTypes.object.isRequired,
  prefix: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  tagName: PropTypes.elementType.isRequired,
  icon: PropTypes.node,
  withSign: PropTypes.string.isRequired,
  formattedValue: PropTypes.string.isRequired,
  showSuffix: PropTypes.bool.isRequired,
  currency: PropTypes.string,
};

export default CurrencyFormatterContent;
